import type { TFunction } from 'i18next';

export const getHistoryFieldLabel = (field: string, t: TFunction) => {
  const labels: Record<string, string> = {
    name: t('masterList.journalName') as string,
    publisher: t('masterList.columnPublisher') as string,
    licenses: t('masterList.columnLicenseOption') as string,
    publishing_model: t('masterList.columnPublishingModel') as string,
    issn_e: t('masterList.columnIssnE') as string,
    issn_p: t('masterList.columnIssnP') as string,
    subjects: t('masterList.columnSubject') as string,
    url: 'URL',
  };

  if (labels[field]) return labels[field];

  return field
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
